import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { AdvancedShowSettingsPage } from './advanced-show-settings.page';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      {
        path: '',
        component: AdvancedShowSettingsPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [AdvancedShowSettingsPage],
})
export class AdvancedShowSettingsModule {}
